import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

const initialState = {
  campaigns: [],
  selectedCampaignId: null,
  filteredAdGroups: [],
  copyAsOff: false,
  campaignLoading: false,
  adGroupLoading: false,
}

export const fetchCampaigns = createAxiosThunk(
  'dashboard/copyAdGroups/fetchCampaigns',
  bizChannelId => api.ad.getBizChannelNotDeletedCampaigns(bizChannelId)
)

export const fetchFilteredAdGroups = createAxiosThunk(
  'dashboard/copyAdGroups/fetchAdGroups',
  async (noArgs, { getState }) => {
    const { selectedIds, content } = getState().dashboard.table.adGroupTable
    const {
      data: { adGroupIds },
    } = await api.ad.copyableAdGroups(selectedIds)
    const filteredContent = selectedIds
      .filter(selectedId => adGroupIds.includes(selectedId))
      .map(selectedId => content.find(item => item.id === selectedId))
    return api.response(filteredContent)
  }
)

const maxCopyCount = 10

export const copyAdGroupsSlice = createSlice({
  name: 'dashboard/copyAdGroups',
  initialState,

  reducers: {
    setSelectedCampaignId: (state, { payload }) => {
      state.selectedCampaignId = payload
    },
    setCopyAsOff: (state, { payload }) => {
      state.copyAsOff = payload
    },
    resetAdGroupCopy: () => initialState,
  },

  extraReducers: builder => {
    builder.addCase(fetchCampaigns.pending, state => {
      state.campaignLoading = true
    })

    builder.addCase(fetchCampaigns.fulfilled, (state, { payload }) => {
      state.campaigns = payload.campaigns
      state.campaignLoading = false
    })

    builder.addCase(fetchCampaigns.rejected, state => {
      state.campaignLoading = false
    })

    builder.addCase(fetchFilteredAdGroups.pending, state => {
      state.adGroupLoading = true
    })

    builder.addCase(fetchFilteredAdGroups.fulfilled, (state, { payload }) => {
      state.filteredAdGroups = payload
        .slice(0, maxCopyCount)
        .map(({ id, name }) => ({ id, name }))
      state.adGroupLoading = false
    })

    builder.addCase(fetchFilteredAdGroups.rejected, state => {
      state.adGroupLoading = false
    })
  },
})
const { actions, reducer } = copyAdGroupsSlice
export const { resetAdGroupCopy, setSelectedCampaignId, setCopyAsOff } = actions
export default reducer
